<script>
import { defineComponent, ref } from 'vue-demi';
import * as layerNames from '../../services/layerName';
import Layer from '../Layer.vue';
import redPacketsProxy from '../../services/actionSync/red.packet.proxy';
export default defineComponent({
  components: {
    Layer,
  },
  setup () {
    const visible = ref(true);
    const close = () => {
      redPacketsProxy.close();
      visible.value = false;
    };
    return {
      close,
      visible,
      layerName: layerNames.RED_PACKET_FAILED_LAYER,
    };
  },
});
</script>
<template>
  <Layer :layerName="layerName" :visible="visible" maskDirection="Middle">
    <div class="dlrLayer-middle dlrRedPackNewRule">
      <div class="dlrRedPackNewRule-bg">
        <span class="dlrRedPackNewRule-close" @click="close(true)"></span>
        <div class="dlrCollected-title">
          很遗憾
          <br />当前红包已被领完
        </div>
        <a class="dlrCollected-bnt" href="javascript:;" @click="close(true)">
          看看其他优惠
        </a>
      </div>
    </div>
    <div class="dlrLayer-mask"></div>
  </Layer>
</template>
// <style lang="scss">
// @import './scss/Rule.scss';
// </style>
